/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProjectStepType {

    COMPANY_INFORMATION = 'COMPANY_INFORMATION',

    PROJECT_CHARTER = 'PROJECT_CHARTER',

    PROJECT_SETTINGS = 'PROJECT_SETTINGS',

    DESIGN_CRITERIA = 'DESIGN_CRITERIA',

    ARCHITECTURAL_PRINCIPLES = 'ARCHITECTURAL_PRINCIPLES',

    SYSTEM_RECORDING = 'SYSTEM_RECORDING',

    SYSTEM_INTEGRATION_CONFIG = 'SYSTEM_INTEGRATION_CONFIG',

    EVALUATION_CRITERIA = 'EVALUATION_CRITERIA',

    EVALUATION_SUB_CRITERIA = 'EVALUATION_SUB_CRITERIA',

    EVALUATION_CRITERIA_OVERVIEW = 'EVALUATION_CRITERIA_OVERVIEW',

    RFI_EVALUATION_SUBCRITERIA = 'RFI_EVALUATION_SUBCRITERIA',

    RFI_INVITATION_PREVIEW = 'RFI_INVITATION_PREVIEW',

    RFI_INVITATION_LIST = 'RFI_INVITATION_LIST',

    RFI_PROVIDER_RESULTS = 'RFI_PROVIDER_RESULTS',

    RFP_EVALUATION_SUBCRITERIA = 'RFP_EVALUATION_SUBCRITERIA',

    RFP_INVITATION_PREVIEW = 'RFP_INVITATION_PREVIEW',

    RFP_INVITATION_LIST = 'RFP_INVITATION_LIST',

    RFP_PROVIDER_RESULTS = 'RFP_PROVIDER_RESULTS',

    RFD_DEMONSTRATION_AGENDA = 'RFD_DEMONSTRATION_AGENDA',

    RFD_DEMONSTRATION_USE_CASES = 'RFD_DEMONSTRATION_USE_CASES',

    RFD_INVITATION_PREVIEW = 'RFD_INVITATION_PREVIEW',

    RFD_INVITATION_LIST = 'RFD_INVITATION_LIST',

    RFD_PROVIDER_EVALUATION = 'RFD_PROVIDER_EVALUATION',

    RFD_PROVIDER_RESULTS = 'RFD_PROVIDER_RESULTS',

    RFQ_PROPOSAL_PARAMETER = 'RFQ_PROPOSAL_PARAMETER',

    RFQ_INVITATION_PREVIEW = 'RFQ_INVITATION_PREVIEW',

    RFQ_PROVIDER_INVITATION = 'RFQ_PROVIDER_INVITATION',

    RFQ_RESULTS = 'RFQ_RESULTS',

    RFQ_AGGREGATED_RESULTS = 'RFQ_AGGREGATED_RESULTS',

    OVERALL_RESULTS_OVERVIEW = 'OVERALL_RESULTS_OVERVIEW',

    OVERALL_RESULTS_DECISION = 'OVERALL_RESULTS_DECISION',

    DECISION_REPORT_OVERVIEW = 'DECISION_REPORT_OVERVIEW',

    DECISION_REPORT_EXPORT_CONFIGURATION = 'DECISION_REPORT_EXPORT_CONFIGURATION',

    NOT_IMPLEMENTED = 'NOT_IMPLEMENTED'
}

